import React, { useState } from 'react';
import { Step, StepLabel, Stepper as BaseStepper } from '@material-ui/core';

import { StepperProps } from './Stepper.types';
import { useStyles } from './Stepper.styles';
import { StepConnector } from './stepConnector/StepConnector';
import { StepIcon } from './stepIcon/StepIcon';

export const Stepper = ({ steps, finishStep }: StepperProps) => {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);

  const goToNextStep = () => {
    setActiveStep(s => s + 1);
  };

  const goToPreviousStep = () => {
    if (activeStep - 1 >= 0) {
      setActiveStep(s => s - 1);
    }
  };

  return (
    <div>
      <BaseStepper activeStep={activeStep} alternativeLabel connector={<></>} className={classes.stepper}>
        {steps.map((step, index) => (
          <Step key={step.label} className={classes.step}>
            <StepLabel StepIconComponent={StepIcon} className={classes.label}>
              {step.label}
            </StepLabel>
            {index > 0 && <StepConnector numberOfSteps={steps.length} currentIndex={index} activeStep={activeStep} />}
          </Step>
        ))}
      </BaseStepper>
      {activeStep < steps.length && (
        <div className={classes.content}>{steps[activeStep].content(goToNextStep, goToPreviousStep)}</div>
      )}
      {activeStep >= steps.length && finishStep}
    </div>
  );
};
